// src/app/assign-users/assign-users.component.ts

import { Component, EventEmitter, Input, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import {
  ConfirmEventType,
  ConfirmationService,
  Message,
  MessageService,
  TreeNode,
} from 'primeng/api';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { cloneDeep } from 'lodash';
import { link, breadcrumb, stat } from '../admin/layout/header/header.component';
import { OrganizationChart } from 'primeng/organizationchart';
import { OrganizationUnit } from '../misc/interface/organization-unit';
import { TranslatorPipe } from '../services/translator.pipe';



@Component({
  selector: 'app-assign-users',
  templateUrl: './assign-users.component.html',
  styleUrls: ['./assign-users.component.scss'],
  providers: [ConfirmationService, MessageService],

})
export class AssignUsersComponent {

  @Input() userFetchUrl: string = '';
  @Output() selectedUsersList: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectionData: any[] = [];
  @Input() fromCreateTraining: string = '';
  @Input() query: any = null
  @Input() isTraining !: boolean
  @Input() requestedUser: any = undefined
  @Input() managerLimit: any = undefined
  @Input() fromMS: any = false;


  staticURL = GlobalConstants.staticFilesURL;
  skelition: boolean = true;

  constructor(
    private dataService: DataService,
    private ouService: OrgUnitsService,
    public permissionService: PermissionHandlerService,
    private messageService: MessageService
  ) {

    

   }

  data: any;
  attributeFilterValue: string = '';
  attributeFilterValueSelected: string = '';
  filteredData: any = [];
  busyUsers: any = []
  filteredSelection: any;

  treeData: any[] = [];
  parentOUS = [
    'الجهات المشاركة',
  ];

  messages: Message[] = [];

  //filters
  oufilter: any = undefined;
  selectedOuFilter: any = undefined;

  userSchedule: any
  showScheduleFlag: boolean = false

  ngOnInit() {
    this.messages = [];
    Promise.all([this.getTreeData(), this.getData()]).then(e => {
      //need to remove this check
      if (this.fromCreateTraining) {
        this.selectionData = this.data;
        this.filteredSelection = this.selectionData;
        this.filteredData = [];
      }
      else if (this.selectionData) {
        this.selectionData = this.selectionData.map(d => {
          this.filteredData = this.filteredData?.filter((f: any) => f._id != d);
          return this.data?.find((u: any) => u._id == d)
        }).filter(f => f != undefined && f != null);
        this.filteredSelection = this.selectionData;
      }
      this.skelition = false;
    })
  }




  //Getting Initial Data in bulk
  getData = async () => {
    try {
      let res: any
      let ous: any[] = await this.permissionService.extractOUChildren("ASSIGN_USERS", 'a')
      if (ous.length > 0 && !this.parentOUS.includes(ous[0].label) && this.userFetchUrl == 'user') {
        if (!ous[0]._id) {
          ous = ous.flatMap(e => e.children.map((f: any) => f._id))
        }
        console.log('PERMISSION OUS', ous);
        this.userFetchUrl = 'user/ous';
        this.query = { data: ous }
      }

      if (this.query == null) {
        res = await this.dataService.getData(this.userFetchUrl);
      } else {
        res = await this.dataService.postData(this.userFetchUrl, this.query)
      }

      let data = res.data

      // removing users taht are bzy to attend training
      if (this.isTraining) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].allowed == false) {
            this.busyUsers.push(data[i]);
            data.splice(i, 1);
            i--;
          }
        }
      }

      this.data = this.filteredData = data;
      this.busyUsers
      this.sortView();
    } catch (error) {
      console.log(error);
    }
  };




  //Get tree data and as per the  permission
  async getTreeData() {
    this.treeData = await this.ouService.getOrgUnits();
  }

  //Service filter function
  filterFunction(fromSelected: boolean) {
    if (fromSelected) {
      console.log(this.selectionData);
      this.filteredSelection = this.selectionData;
      this.filteredSelection = this.filterData(this.selectionData, this.selectedOuFilter);
      console.log(this.filteredSelection);
    } else {
      this.filteredData = this.data;
      this.filteredData = this.filterData(this.filteredData, this.oufilter);
      this.sortView()
    }
  }

  //Refresh to initial state
  refresh() {
    this.oufilter = undefined;
    this.filteredData = this.data;
    this.filteredSelection = this.selectionData;
    this.selectedOuFilter = undefined;
    this.attributeFilterValue = '';
    this.attributeFilterValueSelected = '';
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  exit(emit: boolean) {
    if (emit) {

      if (this.managerLimit && this.selectionData.length > this.managerLimit) {
        this.messageService.add({ severity: 'error', summary: this.translate('Error'), detail: this.translate('Total number of users that can be assigned are :') + this.managerLimit })
        return
      }

      this.selectedUsersList.emit({ emit: true, users: this.selectionData });
    } else {
      this.selectedUsersList.emit({ emit: false });
    }
    // this.selectionData = [];
    this.refresh();
  }

  updateSelection(event: any, isSingle: boolean, isSelection: boolean) {
    console.log(this.filteredData, this.filteredSelection, this.selectionData);
    if (isSingle && !isSelection) {
      this.filteredData = this.filteredData.filter((f: any) => f._id != event.data._id);
      console.log(this.filteredData);
    } else if (isSingle && isSelection) {
      this.filteredData.push(event.data);
    } else if (!isSingle && !isSelection) {
      this.selectionData.forEach((s: any) => {
        this.filteredData = this.filteredData.filter((f: any) => f._id != s._id);
      })
    } else if (!isSingle && isSelection) {
      this.filteredData.push(...this.filteredSelection);
    }
    this.filteredSelection = this.selectionData;
    this.sortView();
  }

  sortView() {
    this.filteredData.sort((a: any, b: any) => a.name.first.localeCompare(b.name.first))
  }

  //Function to get common fields of the selected data
  filterData(data: any[], value: any) {
    return data.filter(u => {
      let ou = u.ou.find((o: OrganizationUnit) => o._id == value._id)
      if (ou) {
        return true;
      }
      return false;
    })
  }

  attrubiteFilter(value: string, fromSelected: boolean) {
    if (fromSelected) {
      if (value) {
        this.filteredSelection = this.selectionData.filter((user: any) => (user?.email?.includes(value)
          || user?.phone?.includes(value)
          || user?.location?.name?.includes(value)
          || (user?.name?.first + ' ' + user?.name?.middle + ' ' + user?.name?.last).includes(value)
        )
        );
      } else {
        this.filteredSelection = this.selectionData;
      }
    } else {
      if (value) {
        this.filteredData = this.data.filter((user: any) => (user?.email?.includes(value)
          || user?.phone?.includes(value)
          || user?.location?.name?.includes(value)
          || (user?.name?.first + ' ' + user?.name?.middle + ' ' + user?.name?.last).includes(value)
        )
        );
      } else {
        this.filteredData = this.data;
      }
    }
  }



  viewDetails(data: any) {
    this.userSchedule = data.attended
    this.showScheduleFlag = true
  }

  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }
}
